// English. Add a key here AND in vi.js. Reference via t('key') or data-i18n="key".
export default {
  // Brand / shell
  app_subtitle: '2026 KPI Dashboard',

  // PIN gate
  pin_subtitle: '2026 kpi dashboard',
  pin_wrong: 'Incorrect PIN',
  pin_enter: 'enter your PIN',
  cancel: 'cancel',

  // Role selector
  who_are_you: 'who are you?',
  rs_car: 'car bu',
  rs_hj: 'heli-jet bu',
  rs_mkt: 'mkt team',
  rs_coo: 'management view · all roles (coo / manager)',

  // Header
  hdr_import: 'import actuals',
  hdr_team: 'team view',
  hdr_switch: 'switch role',
  hdr_docs: 'docs',

  // Tabs
  tab_summary: 'summary',
  tab_weekly: 'overview',
  tab_monthly: 'monthly results',
  tab_quarterly: 'quarterly',
  tab_ytd: 'ytd',
  tab_bonus: 'bonus',
  tab_kpi_report: 'kpi report',
  tab_marketing: 'marketing',

  // Specialist period bar
  edit_actuals_hint: 'edit actuals below → bonus updates in real time',

  // Sync indicator
  sync_loading: 'syncing…',
  sync_ok: '✓ synced',
  sync_offline: '⚠ offline — cached data',
  sync_toast_offline: '⚠ could not reach Google Sheets — showing cached / mock data',
  retry: 'retry',

  // Bonus levels (used by bonusLevel())
  bonus_fail: 'fail',
  bonus_dat: 'meeting target',
  bonus_xs: 'excellent',
  bonus_vxs: 'exceptional',
  bonus_fail_hint: '< 80% — no bonus',
  bonus_dat_hint: '80–99% — ×score',
  bonus_xs_hint: '100–120% — ×1.2',
  bonus_vxs_hint: '> 120% — ×1.5',

  // Config modal
  config_title: 'dashboard config',
  config_intro: 'Combined view: managers see manager dashboard, specialists see personal KPI view.',
  pin_mgmt: 'team pin management',
  pin_save: 'save pin changes',
  pin_reset: 'reset to default',
  email_mgmt: 'team email addresses',
  email_save: 'save emails',
  h2_fc_title: 'h2 forecast targets (USD)',
  h2_fc_hint: 'edit monthly gmv targets for jun–dec 2026',
  h2_fc_save: 'save forecast',
  h2_fc_reset: 'reset to default',

  // Import modal
  import_title: 'Import Actuals',
  import_subtitle: 'Upload CSV or Excel to update KPI actuals',
  import_download_template: 'Download Template CSV',
  import_format_hint: 'Format: role_key, kpi_index, month (1-12), value — or GMV: bu, month, actual_gmv',
  import_dropzone: 'Drag & drop file here or click to choose',
  import_dropzone_hint: '.csv · .xlsx · .xls',
  import_preview: 'Preview data',
  import_choose_other: '← Choose another file',
  import_apply: '✓ Apply Actuals',
  import_huy: 'Cancel',
  import_skipped: 'rows skipped',

  // Email modal
  email_modal_title: 'send monthly kpi results',
  email_modal_hint: 'preview email content per role — click send to open in your email client',
  email_no_set: 'no email set',
  email_send: '✉ send',
};
